import get from 'lodash.get';
import React from 'react';
import styled from 'react-emotion';
import posed from 'react-pose';
import CategoryLink from '@jetshop/ui/CategoryLink';
import CategoryHeader from '../CategoryPage/CategoryHeader';
import MaxWidth from '../Layout/MaxWidth';
import CategoryHeaderLoadingState from '../CategoryPage/CategoryHeaderLoadingState';

const Container = styled(MaxWidth)``;

const CategoryWrapper = styled('div')``;

const Items = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`;
const Item = styled('div')`
  height: 130px;
  width: 16.66667%;
  padding: 0.5rem;
  ${({ theme }) => theme.below.lg} {
    width: 25%;
  }
  ${({ theme }) => theme.below.md} {
    width: 50%;
  }
  a,
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100%;
    background: #f3f3f3;
    color: black;
    text-decoration: none;
  }

  span {
    background: ${({ theme }) => theme.colors.primary};
    color: black;
    font-weight: bold;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 25px;
  }

  h3 {
    line-height: 1.3;
    font-size: 1rem;
    width: 100%;
    padding: 0 10px;
    display: block;
  }
`;

// Fade in the product grid once it loads
const ContainerAnimation = posed.div({
  closed: {
    opacity: 0,
  },
  open: { opacity: 1 },
});

// This wraps the filters and the product grid and staggers their animation.
// So the FilterAnimation will run first, and then 200ms later the
// ContainerAnimation will run.
const StaggerAnimation = posed.div({
  open: { staggerChildren: 200 },
});

const BrandsList = ({ brands }) => {
  var subCats = [];
  for (let i = 0; i < brands.length; i++) {
    const subCat = brands[i];
    subCats.push(subCat);
  }
  let data = subCats.reduce((r, e) => {
    let group = e.name[0];
    if (!r[group]) r[group] = { group, children: [e] };
    else r[group].children.push(e);
    return r;
  }, {});
  let result = Object.values(data);

  return subCats.length > 0 ? (
    <Items>
      {result.map((result, index) => (
        <>
          <Item key={index}>
            <span>{result.group}</span>
          </Item>
          {result.children.map((item, index) => (
            <Item key={index}>
              <CategoryLink category={item}>
                <h3>{item.name}</h3>
              </CategoryLink>
            </Item>
          ))}
        </>
      ))}
    </Items>
  ) : null;
};

const BrandsPage = ({ category, cacheHit, result }) => {
  return (
    <CategoryWrapper>
      <>
        {!cacheHit ? (
          // Show a dummy header if we don't have cached data
          <CategoryHeaderLoadingState />
        ) : (
          <CategoryHeader
            category={category}
            parents={get(result.data, 'route.parents')}
          />
        )}

        <Container>
          <StaggerAnimation pose={cacheHit && 'open'}>
            <ContainerAnimation pose={cacheHit ? 'open' : 'closed'}>
              {category && category.subcategories ? (
                <BrandsList brands={category.subcategories} />
              ) : null}
            </ContainerAnimation>
          </StaggerAnimation>
        </Container>
      </>
    </CategoryWrapper>
  );
};

export default BrandsPage;
